export default function stripURLParams(paramsArray) {
  let newURL = window.location.toString();
	if (newURL.indexOf("?") > 0) {
		paramsArray.forEach((name) => {
			newURL = removeParam(name, newURL);
		})
		window.history.replaceState({}, document.title, newURL);
	}
}

function removeParam(name, _url){
	var reg = new RegExp("((&)*" + name + "=([^&]*))","g");
	return _url.replace(reg,'');
}
